import type { AnalyticsEvent, BotIdTags } from "./types";

import { EventName } from "@homeinstead/shared";

type FormSubmissionResult =
  | "success"
  | "duplicate"
  | "server-error"
  | "validation-error";

type CareerFormSubmitAnalyticsEvent = AnalyticsEvent & {
  franchise_number?: string;
  form_id: string;
  form_submission_result: FormSubmissionResult;
  form_submission_intent: "career";
  page_url: string;
  lang: string;
  tags: BotIdTags;
};

const CareerFormSubmitEvent = ({
  franchiseNumber,
  result,
  page_url,
  tags,
}: {
  franchiseNumber?: string | undefined;
  result: FormSubmissionResult;
  page_url: string;
  tags: BotIdTags;
}): CareerFormSubmitAnalyticsEvent => ({
  event: EventName.CAREER_FORM_SUBMIT,
  form_id: "career-inquiry-form",
  form_submission_intent: "career",
  form_submission_result: result,
  franchise_number: franchiseNumber,
  lang: "en",
  page_url: page_url,
  tags,
});

export { CareerFormSubmitEvent };
